import { render } from "./VehicleOrderDetail.vue?vue&type=template&id=78324f28&scoped=true&bindings={}"
import script from "./VehicleOrderDetail.vue?vue&type=script&lang=ts"
export * from "./VehicleOrderDetail.vue?vue&type=script&lang=ts"

import "./VehicleOrderDetail.vue?vue&type=style&index=0&id=78324f28&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78324f28"

export default script